CancelModalCtrl = ($scope, $modalInstance, CancelModalService) ->
  $scope.ok = ->
    CancelModalService.startCancellation()

  $scope.cancel = ->
    $modalInstance.dismiss('cancel')

CancelModalCtrl.$inject = [
  '$scope'
  '$modalInstance'
  'CancelModalService'
]

module.exports = CancelModalCtrl




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/cancel-modal/cancel-modal-controller.coffee